import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, CheckCircle, Zap, ShieldCheck, Brain, HeartPulse } from 'lucide-react';
export function ProblemSolution() {
  const problems = ['Querés entrenar pero nunca encontrás tiempo', 'Sentís que necesitás gimnasio para mejorar', 'Empezás motivado pero perdés constancia', 'No sabés qué ejercicios hacer'];
  const solutions = [{
    icon: Zap,
    text: 'Entrenar en poco tiempo'
  }, {
    icon: ShieldCheck,
    text: 'Fortalecer tu cuerpo'
  }, {
    icon: Brain,
    text: 'Crear disciplina'
  }, {
    icon: HeartPulse,
    text: 'Sentirte mejor física y mentalmente'
  }];
  return <section className="py-24 bg-gray-900 text-white relative overflow-hidden" data-id="element-159">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10" data-id="element-160">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-rose-500 rounded-full blur-[128px]" data-id="element-161" />
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-rose-900/20 to-transparent" data-id="element-162" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-163">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-164">
          {/* Problem Side */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-165">
            <div className="flex items-center gap-2 text-rose-400 font-semibold mb-4" data-id="element-166">
              <AlertCircle className="w-5 h-5" data-id="element-167" />
              <span data-id="element-168">EL PROBLEMA</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-169">
              Probablemente te pasa que…
            </h2>

            <ul className="space-y-5 mb-8" data-id="element-170">
              {problems.map((prob, idx) => <li key={idx} className="flex items-start gap-3 text-gray-300 text-lg" data-id="element-171">
                  <div className="w-1.5 h-1.5 rounded-full bg-rose-500 mt-2.5 flex-shrink-0" data-id="element-172" />
                  {prob}
                </li>)}
            </ul>

            <div className="p-6 bg-white/5 border border-white/10 rounded-2xl backdrop-blur-sm" data-id="element-173">
              <p className="text-xl font-medium text-rose-100" data-id="element-174">
                No necesitás más tiempo. Solo necesitás un sistema simple que
                puedas mantener.
              </p>
            </div>
          </motion.div>

          {/* Solution Side */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white text-gray-900 rounded-3xl p-8 md:p-10 shadow-2xl" data-id="element-175">
            <div className="flex items-center gap-2 text-rose-600 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-176">
              <CheckCircle className="w-5 h-5" data-id="element-177" />
              <span data-id="element-178">LA SOLUCIÓN</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-179">
              Ejercitá en Casa
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-180">
              Una guía práctica diseñada para ayudarte a crear el hábito del
              ejercicio en solo 30 días con un método simple que podés hacer
              desde tu casa.
            </p>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-181">
              {solutions.map((sol, idx) => <div key={idx} className="flex flex-col gap-3 p-4 rounded-2xl bg-rose-50 border border-rose-100" data-id="element-182">
                  <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600" data-id="element-183">
                    <sol.icon className="w-5 h-5" data-id="element-184" />
                  </div>
                  <span className="font-semibold text-gray-800" data-id="element-185">
                    {sol.text}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}